import "./i18n";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Horas from "./pages/Horas";
import Reportes from "./pages/Reportes";
import Agenda from "./pages/Agenda";
import Fotos from "./pages/Fotos";
import Clientes from "./pages/Clientes";
import Aprobaciones from "./pages/Aprobaciones";
import Funcionarios from "./pages/Funcionarios";
import Documentos from "./pages/Documentos";
import Cierres from "./pages/Cierres";
import Archivo from "./pages/Archivo";
import Gastos from "./pages/Gastos";
import Ingresos from "./pages/Ingresos";
import { Toaster } from "./components/ui/sonner";

function Protected({ children, adminOnly = false }) {
  return (
    <ProtectedRoute adminOnly={adminOnly}>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/horas" element={<Protected><Horas /></Protected>} />
          <Route path="/reportes" element={<Protected><Reportes /></Protected>} />
          <Route path="/agenda" element={<Protected><Agenda /></Protected>} />
          <Route path="/fotos" element={<Protected><Fotos /></Protected>} />
          <Route path="/clientes" element={<Protected adminOnly><Clientes /></Protected>} />
          <Route path="/aprobaciones" element={<Protected adminOnly><Aprobaciones /></Protected>} />
          <Route path="/funcionarios" element={<Protected adminOnly><Funcionarios /></Protected>} />
          <Route path="/presupuestos" element={<Protected adminOnly><Documentos tipo="presupuesto" /></Protected>} />
          <Route path="/facturas" element={<Protected adminOnly><Documentos tipo="factura" /></Protected>} />
          <Route path="/cierres" element={<Protected adminOnly><Cierres /></Protected>} />
          <Route path="/archivo" element={<Protected adminOnly><Archivo /></Protected>} />
          <Route path="/gastos" element={<Protected adminOnly><Gastos /></Protected>} />
          <Route path="/ingresos" element={<Protected adminOnly><Ingresos /></Protected>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
